import { BaseAsset } from "../../base";
import { ExternalAssetSource } from "../../../types";

/**
 * Shared helper: derive a display name from a Pixabay pageURL.
 * - Images:  "Autumn Leaves" (strips trailing ID number, capitalises words)
 * - Videos:  "Pixabay Video 12345" (uses the trailing numeric ID)
 */
function capitalizeFirstLetter(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function deriveImageName(pageURL: string): string {
  return pageURL
    .split('/')
    .slice(-2, -1)[0]
    .split('-')
    .slice(0, -1)
    .map(capitalizeFirstLetter)
    .join(' ');
}

export function deriveVideoName(pageURL: string): string {
  const id = pageURL.substring(0, pageURL.length - 1).split('/').pop()?.split('-').pop() ?? '';
  return `Pixabay Video ${id}`;
}

/**
 * Abstract base for all Pixabay assets.
 * Concrete subclasses handle images and videos separately.
 */
export abstract class BasePixabayAsset extends BaseAsset {
  protected pageURL: string;
  protected tags: string[];
  protected user: string;
  protected popularity: number;
  protected downloads: number;

  constructor(pageURL: string, tags: string, user: string, popularity: number, downloads: number) {
    super();
    this.pageURL = pageURL;
    this.tags = tags.split(', ');
    this.user = user;
    this.popularity = popularity;
    this.downloads = downloads;
  }

  getId(): string {
    return this.pageURL;
  }

  setName(_name: string): void {
    console.warn('Pixabay assets cannot be renamed');
  }

  getWorkspaceId(): string | undefined {
    return undefined;
  }

  getSource(): string {
    return ExternalAssetSource.Pixabay;
  }

  downloadFileVersion(_versionId: string): Promise<{ blob: Blob; filename: string }> {
    return Promise.reject(new Error('Versioning not supported'));
  }
}
